import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';

export const BannerSkeletonWrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: ${rem(50)};
`;

export const BannerContentContainer = styled.div`
    flex-direction: column;
    width: 100%;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: ${rem(20)};
    margin-top: ${rem(20)};
`;
